/** @file QUAD_FRAGMENT_GLSL: raster's tile sampling, alpha test at 0.5 (raster's 128), opaque colour. */
import { SAMPLE_TILE_GLSL } from '@zilo/pose3d-runtime-babylon/draw/sampleTileGlsl';

/** `SAMPLE_TILE_GLSL` (cut discard included), then discards alpha < 0.5 and writes the texel colour opaque. */
export const QUAD_FRAGMENT_GLSL = `${SAMPLE_TILE_GLSL}
void main(void) {
  vec4 c = sampleTile();
  if (c.a < 0.5) discard;
  gl_FragColor = vec4(c.rgb, 1.0);
}
`;
